import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { updateSortType } from '../../../../Features/inventoryManagementSlice';

function SortKebab({ kebabOpen, boxRef }) {
    const dispatch = useDispatch();

    const [kebabVisible, setKebabVisible] = useState(false);

    const filters = useSelector((state) => state.inventoryManagement.filters);

    const handleOptionChange = (event) => {
        dispatch(updateSortType(event.target.value));
    };

    useEffect(() => {
        if(kebabOpen) {
            setKebabVisible(true);
        } else {
            setKebabVisible(false);
        }
    }, [kebabOpen]);

    return (
        <div ref={boxRef} onClick={(e) => {e.stopPropagation()}} className={`${kebabVisible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out absolute right-0 top-9 z-10 w-60 pb-2 rounded-lg overflow-hidden bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D]`}>
            <div className="bg-[#F5F5F5] p-[7px_2px_8px_12px]">
                <h1 className='font-semibold text-[14px] leading-[22px] text-left text-[#121212]'>Sort by</h1>
            </div>

            <div className="flex flex-col gap-2 my-2">
                <div className="flex items-center justify-between px-3 py-1">
                    <label htmlFor="high-to-low-radio" className='font-medium text-[14px] leading-6 text-[#666666] cursor-pointer select-none'>
                        <input 
                            id='high-to-low-radio'
                            value='high-to-low' 
                            type="radio" 
                            checked={filters.sortType === 'high-to-low'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        Price: High to Low
                    </label>

                    <label htmlFor='high-to-low-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${filters.sortType === 'high-to-low' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                filters.sortType === 'high-to-low' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>
                </div>

                <div className="flex items-center justify-between px-3 py-1">
                    <label htmlFor="low-to-high-radio" className='font-medium text-[14px] leading-6 text-[#666666] cursor-pointer select-none'>
                        <input 
                            id='low-to-high-radio'
                            value='low-to-high' 
                            type="radio" 
                            checked={filters.sortType === 'low-to-high'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        Price: Low to high
                    </label>

                    <label htmlFor='low-to-high-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${filters.sortType === 'low-to-high' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                filters.sortType === 'low-to-high' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>
                </div>

                <div className="flex items-center justify-between px-3 py-1">
                    <label htmlFor="newly-added-radio" className='font-medium text-[14px] leading-6 text-[#666666] cursor-pointer select-none'>
                        <input 
                            id='newly-added-radio'
                            value='newly-added' 
                            type="radio" 
                            checked={filters.sortType === 'newly-added'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        Newly Added
                    </label>

                    <label htmlFor='newly-added-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${filters.sortType === 'newly-added' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                filters.sortType === 'newly-added' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>
                </div>
            </div>
        </div>
    );
}

export default SortKebab;
